// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICarrierIdPropertyDto
 */
export interface ICarrierIdPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof ICarrierIdPropertyDto
     */
    carrier_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICarrierIdPropertyDto
     */
    carrier_id_state?: ICarrierIdPropertyDtoCarrierIdStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum ICarrierIdPropertyDtoCarrierIdStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the ICarrierIdPropertyDto interface.
 */
export function instanceOfICarrierIdPropertyDto(value: object): value is ICarrierIdPropertyDto {
    return true;
}

export function ICarrierIdPropertyDtoFromJSON(json: any): ICarrierIdPropertyDto {
    return ICarrierIdPropertyDtoFromJSONTyped(json, false);
}

export function ICarrierIdPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICarrierIdPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'carrier_id': json['carrier_id'] == null ? undefined : json['carrier_id'],
        'carrier_id_state': json['carrier_id_state'] == null ? undefined : json['carrier_id_state'],
    };
}

export function ICarrierIdPropertyDtoToJSON(json: any): ICarrierIdPropertyDto {
    return ICarrierIdPropertyDtoToJSONTyped(json, false);
}

export function ICarrierIdPropertyDtoToJSONTyped(value?: ICarrierIdPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'carrier_id': value['carrier_id'],
        'carrier_id_state': value['carrier_id_state'],
    };
}

